import { deleteRelease, listReleases, type Submission } from '../data/releases'
import { availableTemplates } from '../template/store'
import { sharePdf } from '../share/delivery'
import { button, confirmDialog, el, heading, toast } from '../ui/dom'
import { navigate } from '../router'

export async function homeScreen(): Promise<HTMLElement> {
  const templates = availableTemplates()
  const releases = await listReleases()

  const templateList = el('div', { class: 'stack' })
  if (templates.length === 0) {
    templateList.append(el('p', { class: 'muted', text: 'No usable templates. Add one in Settings.' }))
  }
  for (const template of templates) {
    templateList.append(
      button(template.title, () => navigate(`/sign/${encodeURIComponent(template.id)}`), 'primary'),
    )
  }

  const releaseList = el('div', { class: 'stack' })
  if (releases.length === 0) {
    releaseList.append(el('p', { class: 'muted', text: 'No releases signed yet.' }))
  }
  for (const release of releases) {
    releaseList.append(releaseRow(release))
  }

  return el('div', { class: 'screen' }, [
    el('header', { class: 'app-bar' }, [
      el('h1', { class: 'app-title', text: 'Consent' }),
      button('Settings', () => navigate('/settings'), 'text'),
    ]),
    heading('Start a new form'),
    templateList,
    heading('Signed releases'),
    releaseList,
  ])
}

function releaseRow(release: Submission): HTMLElement {
  const signedAt = new Date(release.signedAtMillis)
  const row = el('div', { class: 'release-row' }, [
    el('div', { class: 'release-main' }, [
      el('p', { class: 'release-name', text: release.signerName || release.pdfFileName }),
      el('p', {
        class: 'release-meta',
        text: `${release.templateTitle} · ${signedAt.toLocaleString()} · ${release.pageCount} ${
          release.pageCount === 1 ? 'page' : 'pages'
        }`,
      }),
    ]),
    button('Send', () => {
      void sharePdf(
        release.pdf,
        release.pdfFileName,
        `${release.templateTitle} - ${release.signerName}`,
        `Signed ${release.templateTitle.toLowerCase()}.`,
      )
    }),
    button('Delete', () => {
      void (async () => {
        const ok = await confirmDialog(
          'Delete this release?',
          'The PDF and its record are removed from this device. Copies you already sent are not affected.',
          'Delete',
        )
        if (!ok) return
        await deleteRelease(release.id)
        row.remove()
        toast('Deleted.')
      })()
    }, 'text'),
  ])
  return row
}
